import { formatCommasNumber } from "@/common/util/format-number-with-commas";
import { UserDto } from "@/types/dto/user-dto";
import { Table } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import { ButtonColor } from "../../../common/enum/button-color";
import { StatusButton } from "../../button/StatusButton";
import { Body14Regular } from "../../typography/Body14Regular";
import { Body14Underline } from "../../typography/Body14Underline";
import { CustomCell } from "../CustomCell";

interface Props {
  data: UserDto;
  index: number;
  startIndex: number;
}

export const Row: React.FC<Props> = ({ data, index, startIndex }) => {
  const navigate = useNavigate();
  const onClickName = () => {
    navigate(`/partner/detail/${data.id}`);
  };

  return (
    <Table.Row
      key={data.id}
      className="bg-white dark:border-gray-700 dark:bg-gray-800"
    >
      <Table.Cell className="font-medium text-gray-900 whitespace-nowrap dark:text-white">
        <CustomCell>
          <Body14Regular>{startIndex - index}</Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell onClick={onClickName}>
        <CustomCell>
          <Body14Underline>{data.name}</Body14Underline>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular>{`${data.businessName || ""}`}</Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular>{`${data.phone || ""}`}</Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular>{`${data.signupCode || ""}`}</Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular>{`${data.grade?.name || ""}`}</Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular>{`${data.quoteCount}건`}</Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular>{`${data.orderCount}건`}</Body14Regular>
        </CustomCell>
      </Table.Cell>
      {/* 원화 3자리 포멧 */}
      <Table.Cell>
        <CustomCell>
          <Body14Regular>{`${formatCommasNumber(
            data.totalSales
          )}`}</Body14Regular>
        </CustomCell>
      </Table.Cell>
      {/* <Table.Cell>{`${user.email || ""}`}</Table.Cell> */}
      {/* 인센티브 할인 */}
      <Table.Cell>
        {/* <CustomCell className="justify-center">{`비활성화`}</CustomCell> */}
        <div className="flex justify-center">
          <StatusButton
            color={
              data.isActiveIncentiveDiscount
                ? ButtonColor.GREEN
                : ButtonColor.CUSTOM_GRAY
            }
          >
            {data.isActiveIncentiveDiscount ? "활성화" : "비활성화"}
          </StatusButton>
        </div>
      </Table.Cell>
      <Table.Cell>
        <div className="flex justify-center">
          <StatusButton
            color={
              data.canPayLater ? ButtonColor.GREEN : ButtonColor.CUSTOM_GRAY
            }
          >
            {data.canPayLater ? "활성화" : "비활성화"}
          </StatusButton>
        </div>
      </Table.Cell>
    </Table.Row>
  );
};
